import { getInvoices, createCreditNote, getConflictedSales, resolveConflict } from '../../../usecases/documents-usecase'
import { printSell, showInvoicePDF } from '../../../usecases/payments-usecase';
import { printReceipt } from '../../../utils/receipt-utils';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { createPdfBlob, createPdfUrl } from '../invoice/controller'
import { EmptyArray } from '../../../app/domain/models/empty/empty'

/**
 * Mapea los datos de la factura para ser mostrados en la tabla
 */
export function invoiceMapper(data) {
    if (!data || data.length === 0) return EmptyArray;

    return data.map((item) => ({
        ...item,
        customer: item.customer,
        state: item.state,
        // Dejamos el renderizado del Chip para la vista o pasamos metadata
        date: item.date,
        consecutive: item.consecutive,
        prefix: item.prefix,
        number: item.number,
        value: item.value,
        cude: item.cufe,
        QRStr: item.QRStr
    }));
}

/**
 * Obtiene la lista de facturas con filtros opcionales
 */
export async function getInvoiceList(page, limit, filters = {}, origin = 'pos') {
    try {
        const { status, date_from, date_to } = filters;
        const data = await getInvoices('', '', page, limit, true, status, date_from, date_to, origin);
        if (!data.data || data.data.length === 0) {
            return { ...data, data: EmptyArray };
        }
        return { ...data, data: invoiceMapper(data.data) };
    } catch (error) {
        console.error('Error fetching invoices:', error);
        throw error;
    }
}

/**
 * Mapea las ventas en conflicto para la tabla
 */
export function conflictedSalesMapper(data) {
    if (!data || data.length === 0) return EmptyArray;

    return data.map((item) => ({
        date: item.date,
        customer: item.customer,
        document: item.prefix && item.number ? `${item.prefix}-${item.number}` : 'N/A',
        total: item.total,
        error_message: item.error_message || '',
        bill_id: item.bill_id,
        conflict_type: item.conflict_type || 'API_EXCEPTION',
        thirds_id: item.thirds_id,
        customer_id: item.customer_id,
        _original: item,
    }));
}

/**
 * Obtiene la lista de ventas en conflicto
 */
export async function getConflictedSalesList(page, limit, origin = 'pos') {
    try {
        const data = await getConflictedSales('', '', page, limit, true, origin);
        if (!data.data || data.data.length === 0) {
            return { ...data, data: EmptyArray };
        }
        return { ...data, data: conflictedSalesMapper(data.data) };
    } catch (error) {
        console.error('Error fetching conflicted sales:', error);
        throw error;
    }
}

/**
 * Resuelve una venta en conflicto
 */
export async function handleResolveConflict(bill_id, force_generate = false) {
    try {
        const uid = localStorage.getItem('uid');
        const cid = localStorage.getItem('cid');

        dispatchCustomEvent('loading-btn');
        const response = await resolveConflict(uid, cid, bill_id, force_generate);
        dispatchCustomEvent('loading-btn');

        if (response.data?.requires_confirmation) {
            return { requires_confirmation: true, message: response.message };
        }

        dispatchCustomEvent('popup', { message: response.message || "Conflicto resuelto", type: "success" });
        return { success: true };
    } catch (error) {
        dispatchCustomEvent('loading-btn');
        const msg = error.response?.data?.message || "Error al resolver conflicto";
        dispatchCustomEvent('popup', { message: msg, type: "error" });
        return { success: false, error: msg };
    }
}

/**
 * Maneja la impresión de una venta
 */
export function sellPrint(data, profile) {
    printSell(data.prefix, data.number)
        .then((response) => {
            let res = response;
            res["data"] = res.invoice;
            printReceipt(res, profile);
        })
        .catch(() => {
            dispatchCustomEvent('popup', { message: "No tienes informacion disponible", type: "warning" });
        });
}

/**
 * Obtiene la URL del PDF de una factura
 */
export async function showInvoice(data) {
    try {
        const response = await showInvoicePDF(data.cude);
        const blob = createPdfBlob(response.data);
        return createPdfUrl(blob);
    } catch (error) {
        dispatchCustomEvent('popup', { message: "No tienes informacion disponible", type: "warning" });
        throw error;
    }
}

/**
 * Crea una nota de crédito para anular una factura
 */
export async function submitCreditNote(data) {
    try {
        const item = data._original || data;
        await createCreditNote(item.prefix, item.number);
        dispatchCustomEvent('loading-btn');
        dispatchCustomEvent('popup', { message: "Nota de credito creada", type: "success" });
        dispatchCustomEvent('reload-invoices');
        return true;
    } catch (error) {
        dispatchCustomEvent('loading-btn');
        const msg = error.response?.data?.message || "Error al procesar la solicitud";
        dispatchCustomEvent('popup', { message: msg, type: "error" });
        throw error;
    }
}
